import { setupI18n } from "@lingui/core";
// import { en, es } from "make-plural/plurals";
import enMessages from "./locales/en/messages.json";
import esMessages from "./locales/es/messages.json";

const browserLocale = navigator.language.split("-")[0];
const defaultLocale = ["en", "es"].includes(browserLocale)
  ? browserLocale
  : "en";

const i18n = setupI18n({
  locales: ["en", "es"],
  locale: defaultLocale,
  messages: {
    en: enMessages,
    es: esMessages,
  },
  //   pluralRules: {
  //     en,
  //     es,
  //   },
});

export default i18n;
